// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"532":"c2205b79","568":"49d9b54c","787":"7183b387"}[chunkId] + ".chunk.js";
};